import { linkToClassPage } from "../../links";

export function linkToClassInsightsPage(classId: string = ":classId") {
  return `${linkToClassPage(classId)}/insights`;
}
